/* eslint-disable camelcase */
import { FormikValues } from 'formik';
import { api } from '../../../components/axios';

export type ServerModel<T> = {
  id: number;
  type: string;
  attributes: T;
};

export type PackageCategory = {
  id: number;
  category_name: string;
  features: any;
};

export type RoadCustomizationsResponse = {
  data: Array<ServerModel<PackageCategory>>;
};

export const fetchFeatureCategories = async (
  token: string
): Promise<RoadCustomizationsResponse> => {
  const response = await api.get("bx_block_custom_packages/categories", {
    headers: { token: token }
  });

  return response.data;
};

export const createCustomFeature = async (
  form: FormikValues,
  token: string
) => {
  const response = await api.post(
    "/bx_block_custom_packages/create_package_feature",
    {
      package_feature: {
        tag: form.featureTag,
        feature_name: form.featureName,
        payment_period: form.featureFrequency,
        default_cost: form.defaultCost,
        payment_frequency: form.priceDetails,
        package_category_id: form.featureCategoryId,
      }
    },
    {
      headers: { token: token },
    }
  );

  return response.data;
};
